import React, { ReactNode } from "react";
import { Text, H1 } from "@amzn/stencil-react-components/text";
import { Row } from "@amzn/stencil-react-components/layout";
import { StatusContainer } from "../appointment-card/status-container";

interface StatusBannerProps {
  /**
   * Header text to display
   */
  title: string;
  /**
   * Optional description text
   */
  description?: string;
  /**
   * Optional data-testid for testing
   */
  testId?: string;
  /**
   * Path to large viewport icon
   */
  largeViewPortImage: string;
  /**
   * Path to small viewport icon (usually same as large)
   */
  smallViewPortImage: string;
  /**
   * Optional children to render below the description
   */
  children?: ReactNode;
  /**
   * Optional class name for the icon
   * (to allow for custom styling)
   */
  iconClassName?: string;
}

/**
 * A general-purpose status banner component that displays a title, optional description,
 * and optional children (buttons, links, etc.) with an icon.
 */
export const StatusBanner = ({
  title,
  description,
  testId,
  largeViewPortImage,
  smallViewPortImage,
  iconClassName,
  children,
}: StatusBannerProps) => {
  return (
    <StatusContainer
      data-testid={testId}
      largeViewPortImage={largeViewPortImage}
      smallViewPortImage={smallViewPortImage}
      iconClassName={iconClassName}
    >
      <H1 fontSize={"T400"} fontWeight={"regular"} textAlign="center" id="main-content">
        {title}
      </H1>

      {description && (
        <Row gridGap={"1rem"}>
          <Text fontSize={"T200"} textAlign="center">
            {description}
          </Text>
        </Row>
      )}

      {children}
    </StatusContainer>
  );
};
